module.exports = __webpack_public_path__ + "static/media/Relative-Book-Web.50b6b9de.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Relative-Book-Web.woff
// module id = 740
// module chunks = 0